import { createAsyncThunk } from "@reduxjs/toolkit";
import { ax } from "src/common/api/apiClient";
import { IApi } from "src/common/typings/app";
import { IAddInventoryItem, IUpdateInventoryItem } from "src/common/typings/warehouse";
// As we are using createAsynThunk, so we are writing our actions separately to provide them in extraReducers

export const getInventoryStatusDetailsDistributionAction = createAsyncThunk(
  "warehouse/getInventoryStatusDetailsDistributionAction", // action string
  async (data: any) => {
    const { unitId, inventoryNameId, filterBy, filterDate } = data;
    try {
      const res = await ax.get<IApi>(
        `/get-inventory-detail-distribution?filterBy=${filterBy}&filterDate=${filterDate}&unitId=${unitId}&inventoryNameId=${inventoryNameId}`
      );
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);

export const getInventoryStatusListingActionNOD = createAsyncThunk(
  "warehouse/getInventoryStatusListingAction", // action string
  async (dates?: any) => {
    const { daily, yearly, monthly, isOtherItemRequest } = dates;
    try {
      if (daily || yearly || monthly) {
        const res = await ax.post<IApi>(
          `/get-all-inventory-status?daily=${daily}&monthly=${monthly}&yearly=${yearly}&IsOtherItemsRequest=${isOtherItemRequest}`
        );
        if (res.data.isSuccess === true && res.data.value) return res.data.value;
        else throw new Error(res.data.error || res.statusText);
      } else {
        const res = await ax.post<IApi>(
          `/get-all-inventory-status?IsOtherItemsRequest=${isOtherItemRequest}`
        );
        if (res.data.isSuccess === true && res.data.value) return res.data.value;
        else throw new Error(res.data.error || res.statusText);
      }
    } catch (error) {
      throw error;
    }
  }
);

export const getInventoryStatusListingAction = createAsyncThunk(
  "warehouse/getInventoryStatusListingAction", // action string
  async (dates?: any) => {
    const { daily, yearly, monthly } = dates;
    try {
      if (daily || yearly || monthly) {
        const res = await ax.post<IApi>(
          `/get-all-inventory-status?daily=${daily}&monthly=${monthly}&yearly=${yearly}`
        );
        if (res.data.isSuccess === true && res.data.value) return res.data.value;
        else throw new Error(res.data.error || res.statusText);
      } else {
        const res = await ax.post<IApi>("/get-all-inventory-status");
        if (res.data.isSuccess === true && res.data.value) return res.data.value;
        else throw new Error(res.data.error || res.statusText);
      }
    } catch (error) {
      throw error;
    }
  }
);
export const getInventoryStatusBannedItemsListingAction = createAsyncThunk(
  "warehouse/getInventoryStatusBannedItemsListingAction", // action string
  async (dates: any) => {
    const { daily, yearly, monthly } = dates;
    try {
      if (daily || yearly || monthly) {
        const res = await ax.post<IApi>(
          `/get-all-inventory-banned_items?daily=${daily}&monthly=${monthly}&yearly=${yearly}`
        );
        if (res.data.isSuccess === true && res.data.value) return res.data.value;
        else throw new Error(res.data.error || res.statusText);
      } else {
        const res = await ax.post<IApi>("/get-all-inventory-banned_items");
        if (res.data.isSuccess === true && res.data.value) return res.data.value;
        else throw new Error(res.data.error || res.statusText);
      }
    } catch (error) {
      throw error;
    }
  }
);

export const getWareHouseListingAction = createAsyncThunk(
  "configuration/getWareHouseListingAction", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-all-warehouse?ShowIsActive=true");
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getInventoryItemStatusListingAction = createAsyncThunk(
  "configuration/getInventoryItemStatusListingAction", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get-all-inventory-status?ShowIsActive=true");
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const addInventoryItemAction = createAsyncThunk(
  "configuration/addInventoryItemAction",
  async (formRecord: IAddInventoryItem) => {
    formRecord.inspectionStatus === ""
      ? (formRecord.inspectionStatus = "0")
      : formRecord.inspectionStatus;
    try {
      const res = await ax.post<IApi>("/create-inventory", formRecord);
      if (res.data.isSuccess === true && res.data.value.isInventoryCreated === true)
        return res.data.value.isInventoryCreated;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getWareHouseDetailsByIdAction = createAsyncThunk(
  "configuration/getWareHouseDetailsByIdAction", // action string
  async (id: number) => {
    try {
      const res = await ax.get<IApi>(`/get-inventory-detail-by-id/${id}`);
      if (res.data.isSuccess === true && res.data.value.inventoryDetail)
        return res.data.value.inventoryDetail;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateInventoryItemAction = createAsyncThunk(
  "configuration/updateInventoryItemAction",
  async (formRecord: IUpdateInventoryItem) => {
    try {
      const res = await ax.put<IApi>("/update-inventory", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const updateInventoryQuantityAction = createAsyncThunk(
  "configuration/updateInventoryQuantityAction",
  async (formRecord: IUpdateInventoryItem) => {
    try {
      const res = await ax.put<IApi>("/update-inventory-quantity", formRecord);
      if (res.data.isSuccess === true && res.data.value) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
export const getAllCargoUnits = createAsyncThunk(
  "warehouse/getAllCargoUnits", // action string
  async () => {
    try {
      const res = await ax.get<IApi>("/get_all-cargo_units");
      if (res.data.isSuccess === true) return res.data.value;
      else throw new Error(res.data.error || res.statusText);
    } catch (error) {
      throw error;
    }
  }
);
